interface DivisorProps extends React.HTMLAttributes<HTMLHRElement> {
	margin?: string;
	className?: string;
	variant?: 'dotted' | 'solid';
}

const variantStyles = {
	dotted: 'border-dotted border-gray-200',
	solid: 'border-solid border-gray-200',
};

export const Divisor = ({
	margin,
	className = '',
	variant = 'dotted',
	...props
}: DivisorProps) => (
	<hr
		className={`border-t ${variantStyles[variant]} ${
			margin ? `my-${margin}` : ''
		} ${className}`.trim()}
		{...props}
	/>
);